import Store from "$common/utils/store";
export default commomImport => [{
  path: `appointment-order`,
  name: 'appointmentOrder',
  meta: {
    title: 'store.appointmentOrder',
    nameCount: 'booking',
    noCache: true
  },
  //  全部订单
  component: commomImport('order-manager/appointment-order')
}];
